import { object, string } from 'yup';
export const driverSchema = object({
    firstName: string().required(),
    lastName: string().required(),
    phoneNumber: string().required(),
    telegramHandle: string().optional(),
    vehicleType: string().oneOf(['tuk_tuk', 'motorbike', 'car', 'other']).required(),
    licensePlate: string().required(),
    payoutMethod: string().oneOf(['cash', 'aba_pay', 'wing', 'acleda_bank', 'other']).required(),
    payoutAccount: string().optional(),
    status: string().oneOf(['active', 'paused', 'inactive']).required(),
    locale: string().oneOf(['km', 'en', 'fr']).required(),
    joinedAt: string().required(),
    notes: string().optional(),
});
